import { wellnub } from '../wellnub.api';

export const getNutritionist = async id => {
  const { data } = await wellnub.get(`/v1/client/user/nutritionist/${id}`);
  return data;
};

export const requestGetInTouch = ({ id, payload, shouldLinkRequest }) =>
  wellnub.post(
    `/v1/client/contact/nutritionist/${id}?shouldLinkRequest=${shouldLinkRequest}`,
    payload,
  );

export const getNutritionistTestSpecs = async key => {
  const { data } = await wellnub.get(
    `/v1/client/testFindNutritionist?childsFrom=${key}`,
  );
  return data;
};

export const getNutritionistByParams = async params => {
  const { data } = await wellnub.get(`/v1/client/user/nutritionist${params}`);
  return data;
};
